import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StylerAccess() {
  const [users, setUsers] = useState(null);

  const load = async () => {
    try { const r = await axios.get(`${API}/template-styler/users`); setUsers(r.data.users); }
    catch (_) { toast.error("Couldn't load users"); setUsers([]); }
  };
  useEffect(() => { load(); }, []);

  const toggle = async (u) => {
    try {
      await axios.put(`${API}/template-styler/users/${u.id}/access`, { allowed: !u.allowed });
      setUsers((prev) => prev.map((x) => (x.id === u.id ? { ...x, allowed: !u.allowed } : x)));
      toast.success(`${u.name}: Template Styler ${!u.allowed ? "enabled" : "disabled"}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't update access");
    }
  };

  if (!users) return <div className="ts-loading"><Loader2 className="animate-spin" size={18} /> Loading…</div>;

  return (
    <section className="ts-panel" data-testid="styler-access">
      <div className="ts-section-head"><span><ShieldCheck size={15} /> Who can use Template Styler</span><small>Editor accounts only. Super admins always have access.</small></div>
      <div className="ts-access-list">
        {users.map((u) => (
          <div key={u.id} className="ts-access-row" data-testid={`styler-access-${u.id}`}>
            <div className="ts-access-who">
              <strong>{u.name}</strong>
              <span>{u.email}{u.editor_admin ? " · editor admin" : ""}{u.role === "super_admin" ? " · super admin" : ""}</span>
            </div>
            {u.role === "super_admin" ? (
              <span className="ts-pill">always</span>
            ) : (
              <button className={`ts-switch ${u.allowed ? "on" : ""}`} onClick={() => toggle(u)} data-testid={`styler-access-toggle-${u.id}`} aria-pressed={u.allowed}>
                <span className="ts-switch-knob" /><span>{u.allowed ? "Enabled" : "Off"}</span>
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
